import { withStyles } from '@material-ui/core';

import Actions from './component';
import styles from './styles';

export default withStyles(styles)(Actions);
